import { HttpService, ModelBase, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { KsefSendParametersModel } from '@skylab-shared/dataModel';
import { RecursiveDiff } from '@skylab-shared/types';

type KsefSendParameters = RecursiveDiff<KsefSendParametersModel, ModelBase>

export class KsefSendParametersQuery extends Query<KsefSendParameters> { }

export class KsefSendParametersQueryHandlerBase implements QueryHandler<KsefSendParametersQuery, KsefSendParameters> {
	private static Url = TaggedUrl.join('system/ksef/send-parameters', [Tags.Api]);

	public constructor(private readonly http: HttpService) { }

	public async handleAsync(_: KsefSendParametersQuery): Promise<KsefSendParameters> {
		const { data } = await this.http.get<KsefSendParameters>(KsefSendParametersQueryHandlerBase.Url);
		return data;
	}
}
